<template>
  <div class="course-item-content flex-start">
    <img :src="courseItemData.image_url" alt="" />
    <div class="info-content">
      <div class="info-title-content">
        <div class="title">{{ courseItemData.title }}</div>
        <div class="sub-title">{{ courseItemData.subtitle }}</div>
      </div>
      <div class="bottom-info">
        <div class="people-count flex-center">
          <img src="https://logo.wondercv.com/banners/7CW4IEUsRw5K7Lq.png" alt="">
          {{ courseItemData.people_count }}
        </div>
        <div class="bottom-btn flex-center" @click="handleClickItem">立即领取</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    courseItemData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  mounted() {},
  components: {},
  watch: {},
  computed: {},
  methods: {
    handleClickItem() {
      this.$emit('handleClickItem', this.courseItemData);
    }
  },
}
</script>
<style scoped lang="scss">
.course-item-content {
  img {
    width: 123px;
    height: 88px;
    border-radius: 6px;
    object-fit: cover;
    margin-right: 16px;
  }
  .info-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 88px;
    .title {
      font-weight: 500;
      color: #404040;
      line-height: 14px;
      margin-bottom: 10px;
    }
    .sub-title {
      font-size: 12px;
      line-height: 12px;
      color: #606060;
    }
  }
  .bottom-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .people-count {
      font-size: 12px;
      color: #606060;
      img {
        width: 18px;
        height: 18px;
        object-fit: contain;
        margin-right: 4px;
      }
    }
    .bottom-btn {
      width: 76px;
      height: 22px;
      background: linear-gradient(to right, #ff9f79, #ff6644);
      color: #fff;
      border-radius: 12px;
      font-size: 12px;
    }
  }
}
</style>
